const Footer = () => {


  return (
    <div className="bg-dark text-white d-flex flex-column" style={{height: '10vh', alignItems: 'center', justifyContent:'center'}}>
      <div className='text-center p-4'>
        {`© 2023 Copyright: `}
        <a className='text-reset fw-bold' href='https://namnguyenhue.com/'>
          NamNguyenHue.com
        </a>
      </div>
    </div>
  )
}

export default Footer;